import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextField } from '@mui/material';
import BasicModal from 'components/Common/BasicModal';
import PrimaryButton from 'components/Common/PrimaryButton';
import { copy } from 'helpers/functions';

interface ShareSuccessModalProps {
    open: boolean;
    documentUrl: string | null;
    onClose: () => void;
}

export const ShareSuccessModal = ({ open, documentUrl, onClose }: ShareSuccessModalProps) => {
    const { t } = useTranslation();
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = () => {
        if (documentUrl) {
            copy({ value: documentUrl, noMessage: false });
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        }
    };

    const handleOpenInNewTab = () => {
        if (documentUrl) {
            window.open(documentUrl, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <BasicModal open={open} onClose={onClose}>
            <Box className="share-success-modal" sx={{ minWidth: 400 }}>
                <h2>{t('web_app.modals.share_success.title')}</h2>
                <p>{t('web_app.modals.share_success.description')}</p>

                <TextField
                    fullWidth
                    value={documentUrl || ''}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    sx={{ mb: 2 }}
                />

                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                    <PrimaryButton
                        text={
                            isCopied
                                ? t('web_app.modals.share_success.copied')
                                : t('web_app.modals.share_success.copy_button')
                        }
                        onClick={handleCopy}
                        className={isCopied ? 'copied' : ''}
                    />
                    <PrimaryButton
                        text={t('web_app.modals.share_success.open_button')}
                        onClick={handleOpenInNewTab}
                    />
                    <PrimaryButton
                        text={t('web_app.modals.share_success.close_button')}
                        onClick={onClose}
                    />
                </Box>
            </Box>
        </BasicModal>
    );
};
